import { AppConfig } from './../../utils/app-config.service';

import { Utils } from '../../utils/utils';
import { TranslateService } from '@ngx-translate/core';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { CommonService } from '@tech-services/common.service';
import {
  ExtendedTestInterface,
  QuestionnaireService,
} from '@techrules/portallib';

import * as Highcharts from 'highcharts/highcharts';

import HC_more from 'highcharts/highcharts-more';
HC_more(Highcharts);

import HC_solidgauge from 'highcharts/modules/solid-gauge';
HC_solidgauge(Highcharts);

import HC_headmap from 'highcharts/modules/heatmap';
import { Subject, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { TechDialogsService } from '../tech-dialogs.service';
HC_headmap(Highcharts);

@Component({
  selector: 'tech-questions-result2',
  templateUrl: './questions-result2.component.html',
  styleUrls: ['./questions-result2.component.scss'],
})
export class QuestionsResult2Component implements OnInit, OnChanges, OnDestroy {
  @Input() testId: string;

  private destroySubject = new Subject();

  Highcharts: typeof Highcharts = Highcharts;
  loading: boolean;
  extendedData: ExtendedTestInterface;

  private commonOptions = {
    chart: {
      type: 'solidgauge',
      backgroundColor: 'transparent',
      width: 200,
      height: 150,
      style: {
        fontFamily: AppConfig.cssVars.fontBase,
        color: AppConfig.cssVars.colors.fontColor,
      },
    },

    title: null,

    credits: {
      enabled: false,
    },

    pane: {
      center: ['50%', '85%'],
      size: '135%',
      startAngle: -90,
      endAngle: 90,
      background: {
        /*
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || '#f9f9f9',
*/
        innerRadius: '60%',
        outerRadius: '100%',
        shape: 'arc',
      },
    },

    exporting: {
      enabled: false,
    },

    tooltip: {
      enabled: false,
    },

    // the value axis
    yAxis: {
      lineWidth: 0,
      tickWidth: 0,
      minorTickInterval: null,
      tickAmount: 2,
      title: {
        text: undefined,
        y: 70,
      },
      labels: {
        y: 16,
        style: {
          color: AppConfig.cssVars.colors.fontColor,
        },
      },
    },

    plotOptions: {
      solidgauge: {
        dataLabels: {
          y: -30,
          borderWidth: 0,
          useHTML: true,
          style: {
            color: AppConfig.cssVars.colors.fontColor,
          },
        },
      },
    },
  };

  commonType = [
    {
      label: this.translate.instant('k003001'),
      color: ' #F85EAB',
    },
    {
      label: 'Sleep Well',
      color: '#eaf5fb',
    },
    {
      label: 'Relaxed',
      color: '#d9edf2',
    },
    {
      label: 'Balanced',
      color: '#b8d6db',
    },
    {
      label: 'Sparkling',
      color: '#79bcd3',
    },
    {
      label: 'Adrenaline',
      color: '#4fa7c1',
    },
  ];

  options1 = {};
  options2 = {};
  options3 = {};

  optR1: string;

  constructor(
    private commonService: CommonService,
    private translate: TranslateService,
    private service: QuestionnaireService,
    private dialogService: TechDialogsService
  ) {}

  ngOnInit(): void {
    this.updateFlag = false;
  }

  ngOnDestroy() {
    this.destroySubject.next(null);
    this.destroySubject.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let property in changes) {
      if (property === 'testId') {
        //console.log('testId = ', this.testId);
        this.service
          .getExtendedTest(this.testId)
          .pipe(
            takeUntil(this.destroySubject),
            catchError((err) => {
              this.commonService.errorManager('questionnaire', err);
              return throwError(err);
            })
          )
          .subscribe((data: ExtendedTestInterface) => {
            this.loading = true;
            this.extendedData = data;

            this.optR1 = Utils.formatString(this.translate.instant('k002960'), [
              this.extendedData.profileName,
              this.getNameP(this.extendedData.profileName),
            ]);

            this.options1 = Highcharts.merge(this.commonOptions, {
              yAxis: {
                stops: [
                  [0.5, '#4FA8C1'],
                  [1, '#4FA8C1'],
                ],
                min: data.investmentObjective.min,
                max: data.investmentObjective.max,
                tickPositions: [
                  data.investmentObjective.min,
                  data.investmentObjective.max,
                ],
              },
              series: [
                {
                  data: [data.investmentObjective.score],
                  dataLabels: {
                    format:
                      '<div style="text-align:center">' +
                      '<span style="font-size:20px">{y}</span><br/>' +
                      '</div>',
                  },
                },
              ],
            });

            this.options2 = Highcharts.merge(this.commonOptions, {
              yAxis: {
                stops: [
                  [0.33, '#4FA8C1'],
                  [0.66, '#4FA8C1'],
                  [1, '#4FA8C1'],
                ],
                min: data.liquidityNeeds.min,
                max: data.liquidityNeeds.max,
                tickPositions: [
                  data.liquidityNeeds.min,
                  data.liquidityNeeds.max,
                ],
              },
              series: [
                {
                  data: [data.liquidityNeeds.score],
                  dataLabels: {
                    format:
                      '<div style="text-align:center">' +
                      '<span style="font-size:20px">{y}</span><br/>' +
                      '</div>',
                  },
                },
              ],
            });

            this.options3 = Highcharts.merge(this.commonOptions, {
              yAxis: {
                stops: [
                  [0.25, '#4FA8C1'],
                  [0.5, '#4FA8C1'],
                  [0.75, '#4FA8C1'],
                  [1, '#4FA8C1'],
                ],
                min: data.riskAppetite.min,
                max: data.riskAppetite.max,
                tickPositions: [data.riskAppetite.min, data.riskAppetite.max],
              },
              series: [
                {
                  data: [data.riskAppetite.score],
                  dataLabels: {
                    format:
                      '<div style="text-align:center">' +
                      '<span style="font-size:20px">{y}</span><br/>' +
                      '</div>',
                  },
                },
              ],
            });

            this.drawProfileMatrix(
              this.extendedData.xScore,
              this.extendedData.yScore
            );
          });
      }
    }
  }

  investObjModal() {
    this.dialogService.openModalDialog(
      '',
      this.translate.instant('k001466'),
      this.translate.instant('k002961'),
      ''
    );
  }

  liquidNeedsModal() {
    this.dialogService.openModalDialog(
      '',
      this.translate.instant('k002966'),
      this.translate.instant('k002962'),
      ''
    );
  }

  riskApetiteModal() {
    this.dialogService.openModalDialog(
      '',
      this.translate.instant('k002957'),
      this.translate.instant('k002963'),
      ''
    );
  }

  private getProfileValue(x, y) {
    const valor = Math.round((32 / 54) * x + y);
    if (valor <= 48) return 48;
    else if (valor > 48 && valor <= 62) return 62;
    else if (valor > 62 && valor <= 76) return 76;
    else if (valor > 76 && valor <= 103) return 103;
    else return 122;
  }

  private getProfileValue2(x, y) {
    const valor = Math.round((32 / 54) * x + y);
    if (valor <= 48) return this.commonType[1].color;
    else if (valor > 48 && valor <= 62) return this.commonType[2].color;
    else if (valor > 62 && valor <= 76) return this.commonType[3].color;
    else if (valor > 76 && valor <= 103) return this.commonType[4].color;
    else return this.commonType[5].color;
  }

  commonOptions2 = {
    chart: {
      type: 'heatmap',
      plotBackgroundColor: 'none',
      height: 400,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
    },
    title: { text: undefined },

    yAxis: {
      title: {
        text: this.translate.instant('k002965'),
        style: {
          color: '#676a6c',
          fontSize: '14px',
          fontFamily: AppConfig.cssVars.fontBase,
        },
      },
      labels: {
        style: {
          fontSize: '8px',
          fontFamily: AppConfig.cssVars.fontBase,
        },
      },
      tickInterval: 2,
      min: 16,
      max: 60,
    },
    xAxis: {
      title: {
        text: this.translate.instant('k002956'),
        style: {
          color: '#676a6c',
          fontSize: '13px',
          fontFamily: AppConfig.cssVars.fontBase,
        },
      },
      labels: {
        style: {
          fontSize: '7px',
          fontFamily: AppConfig.cssVars.fontBase,
        },
      },
      tickInterval: 16,
      max: 105,
    },
    colorAxis: {
      enabled: false,
      visible: false,
    },
    legend: {
      enabled: false,
      visible: false,
    },
    tooltip: {
      enabled: false,
    },
    isDirty: false,
    series: [
      {
        boostThreshold: 10000,
        turboThreshold: Number.MAX_VALUE,
        borderWidth: 0,
        data: [], //dataMatrix,
        dataLabels: {
          enabled: false,
        },
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            minWidth: 576,
          },
          chartOptions: {
            yAxis: {
              title: {
                style: {
                  fontSize: '16px',
                },
              },
            },

            xAxis: {
              title: {
                style: {
                  fontSize: '15px',
                },
              },
              tickInterval: 4,
            },
          },
        },
        {
          condition: {
            minWidth: 768,
          },
          chartOptions: {
            yAxis: {
              title: {
                style: {
                  fontSize: '24px',
                },
              },
              labels: {
                style: {
                  fontSize: '8px',
                },
              },
            },

            xAxis: {
              title: {
                style: {
                  fontSize: '22px',
                },
              },
              tickInterval: 4,
              labels: {
                style: {
                  fontSize: '9px',
                },
              },
            },
          },
        },
      ],
    },
  };

  updateFlag: boolean;

  private drawProfileMatrix(scoreX: number, scoreY: number) {
    var element;
    var dataMatrix = [];
    for (var y = 16; y <= 60; y++) {
      for (var x = 28; x <= 105; x++) {
        element = {
          x: x,
          y: y,
          color:
            x === scoreX && y === scoreY
              ? this.commonType[0].color
              : this.getProfileValue2(x, y),
        };

        dataMatrix.push(element);
      }
    }

    //console.log(dataMatrix);
    this.commonOptions2.series[0].data = dataMatrix;
    this.commonOptions2.isDirty = true;
  }

  private getNameP(profileName: string) {
    // console.log(profileName, this.commonType);
    switch (profileName) {
      case this.commonType[1].label:
        return this.translate.instant('k001512');
      case this.commonType[2].label:
        return this.translate.instant('k002953'); // 'Moderately Conservative';
      case this.commonType[3].label:
        return this.translate.instant('k002954'); //'Moderate';
      case this.commonType[4].label:
        return this.translate.instant('k002955'); //'Moderately Aggressive';
      case this.commonType[5].label:
        return this.translate.instant('k001514');
      default:
        return '---';
    }
  }
}
